import { AlertTriangle } from "lucide-react";
import { fmtSignedCompact, fmtPeriod } from "../../lib/format";

const THRESHOLD = 10;

export function offPlanLocations(budget, location) {
  if (!budget?.months?.length) return [];
  const rows = location === "all"
    ? Object.entries(budget.by_location || {}).map(([loc, g]) => ({ loc, ...g }))
    : budget.deltas?.net_income ? [{ loc: location, ...budget.deltas.net_income }] : [];
  return rows.filter((r) => r.favorable === false && r.pct != null && Math.abs(r.pct) >= THRESHOLD)
    .sort((a, b) => a.abs - b.abs);
}

export default function OffPlanAlert({ budget, location, onOpen }) {
  const rows = offPlanLocations(budget, location);
  if (!rows.length) return null;
  const m = budget.months;
  const span = m.length === 1 ? fmtPeriod(m[0]) : `${fmtPeriod(m[0])} \u2013 ${fmtPeriod(m[m.length - 1])}`;
  return (
    <div className="mb-6 border border-brand-neg/30 bg-brand-neg/5 rounded-lg px-5 py-4" data-testid="off-plan-alert">
      <div className="flex items-center gap-2.5">
        <AlertTriangle className="h-4 w-4 text-brand-neg shrink-0" />
        <p className="text-sm text-brand-ink">
          <span className="font-medium">{rows.length} location{rows.length > 1 ? "s" : ""} more than {THRESHOLD}% behind budget</span>
          <span className="text-brand-tertiary"> · net income, {span}</span>
        </p>
      </div>
      <div className="mt-3 flex flex-wrap gap-2">
        {rows.map((r) => (
          <button key={r.loc} type="button" onClick={() => onOpen?.(r.loc)} data-testid={`off-plan-${r.loc}`}
            className="inline-flex items-center gap-2 rounded-full border border-brand-neg/30 bg-brand-surface px-3 py-1.5 text-xs hover:border-brand-neg transition-colors">
            <span className="text-brand-ink">{r.loc}</span>
            <span className="font-mono text-brand-neg whitespace-nowrap">{fmtSignedCompact(r.abs)}{Math.abs(r.pct) < 200 ? ` (\u2212${Math.abs(r.pct).toFixed(1)}%)` : ""}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
